"use strict";

var globalRfcZip = '';
var globalRfcPhone = '';
var globalLeadID = '';
var runStep2 = 0;
$(function () {
  $('#ajaxloaderimg, .ajaxloaderimg').hide();
  $('.select-options li:last-child').on('click', function () {
    $('.subsc').prop('checked', false);
  });
  $('.select-options li:not(:last-child)').on('click', function () {
    $('.subsc').prop('checked', true);
  });
});
$('#getrfc').click(function () {
  $('#hidden-request-content2').modal('show');
});
$('.cid').change(function () {
  if ($(this).val() == 'ca') {
    $('.inputState').hide();
    $('.canada').show();
  }
  if ($(this).val() == 'mx') {
    $('.inputState').hide();
    $('.mexico').show();
  }
  if ($(this).val() == 'do') {
    $('.inputState').hide();
    $('.distrito').show();
  }
  if ($(this).val() == 'pr') {
    $('.inputState').hide();
    $('.puerto').show();
  }
  if ($(this).val() == 'us') {
    $('.inputState').hide();
    $('.united').show();
  }
});
$.validator.addMethod('customzip', function (value, element) {
  var ctry = $(element).closest('form').find('select[name="country"]').val();
  if (ctry == 'ca') {
    if (/^[a-zA-Z]\d[a-zA-Z]( )?\d[a-zA-Z]\d$/i.test(value)) {
      return true; // FAIL validation when REGEX matches
    } else {
      return false; // PASS validation otherwise
    }
  } else if (value.length >= 5 && value.length <= 7 && $.isNumeric(value)) {
    return true; // PASS validation otherwise
  } else {
    return false; // PASS validation otherwise
  }
}, 'Please enter correct zip/postal code. For Example Canada: <br> A1A 1A1 and for USA: 99999');
$.validator.addMethod('customCountry', function (value, element) {
  //Check which state object is validated--
  var id = $(element).attr('id');
  var selCtry = $("select[name='country']").val();
  if (id == 'state_' + selCtry && value == '') return false;else {
    $('select.inputState').not('select#' + id).val('');
    return true;
  }
}, 'Please select state.');
$.validator.addMethod('lettersonly', function (value, element) {
  return this.optional(element) || /^[a-z\d\-\s]+$/i.test(value);
}, 'Letters only please');
function formatPhone(obj) {
  var numbers = obj.value.replace(/\D/g, ''),
    char = {
      0: '',
      3: '-',
      6: '-'
    };
  obj.value = '';
  for (var i = 0; i < numbers.length; i++) {
    obj.value += (char[i] || '') + numbers[i];
  }
}
$(document).ready(function ($) {
  var phn = $('#rphone, .rphone').val();
  var numbers = phn.replace(/\D/g, ''),
    char = {
      0: '',
      3: '-',
      6: '-'
    };
  phn = '';
  for (var i = 0; i < numbers.length; i++) {
    phn += (char[i] || '') + numbers[i];
  }
  $('#rphone, .rphone').val(phn);
  var valRfcform2 = $('#rfcform2').validate({
    ignore: ':hidden',
    rules: {
      first_name: {
        required: true,
        lettersonly: true
      },
      last_name: {
        required: true,
        lettersonly: true
      },
      email: {
        required: true,
        email: true
      },
      phone: {
        required: true,
        minlength: 12,
        maxlength: 12
      },
      ragree: {
        required: true
      },
      city_state_zip2: {
        required: true,
        minlength: 5,
        maxlength: 7,
        alphanumeric: true
      }
    },
    messages: {
      first_name: {
        required: 'This field is required'
      },
      last_name: {
        required: 'This field is required'
      },
      email: {
        required: 'This field is required.',
        email: 'Please enter a valid email id.'
      },
      phone: {
        required: 'This field is required',
        minlength: 'Please enter minimum 10 numbers.',
        maxlength: 'Please enter maximum 10 numbers.'
      },
      city_state_zip2: {
        required: 'This field is required.',
        minlength: 'Please enter minimum 5 characters.',
        maxlength: 'Please enter maximum 7 characters only.'
      },
      ragree: {
        required: 'Are you agree with terms and conditions.'
      }
    },
    submitHandler: function submitHandler(frm) {
      var ajaxurl = $('#admin-ajax-url').val();
      var remail = $('#signupEmail').val();

      // Check if User has closed the Step2 and then again filling step1.
      // If yes then check if Step1 Data has not been changed
      // It can be checked as when first step is submitted, its data is stored into second step too
      // (in  hidden inputs)

      var second_step_fname = $('#popup_rfc_step2 #step1_first_name').val();
      var second_step_lname = $('#popup_rfc_step2 #step1_last_name').val();
      var second_step_email = $('#popup_rfc_step2 #step1_email').val();
      var second_step_phone = $('#popup_rfc_step2 #rphone, #popup_rfc_step2 .rphone').val();
      var second_step_zip = $('#popup_rfc_step2 #city_state_zip2').val();
      if ($.trim(frm.first_name.value) == $.trim(second_step_fname) && $.trim(frm.last_name.value) == $.trim(second_step_lname) && $.trim(frm.phone.value) == $.trim(second_step_phone) && $.trim(frm.email.value) == $.trim(second_step_email) && $.trim(frm.city_state_zip2.value) == $.trim(second_step_zip) && $('#popup_rfc_step2 #lid').val() != '') {
        $('#btnrfcsubmit').attr('disabled', 'disabled');
        setTimeout(function () {
          $('#popup_rfc_step2').modal('show');
        }, 500);
        $('#ajaxloaderimg, .ajaxloaderimg').hide();
      } else {
        $('#popup_rfc_step2 select.cc-custom-select').val('us');
        $('#popup_rfc_step2 select.mexico, #popup_rfc_step2 select.canada, #popup_rfc_step2 select.puerto, #popup_rfc_step2 select.distrito').hide();
        $('#popup_rfc_step2 select.united').show();
        var ajaxdata = $(frm).serialize() + '&action=requestfc_step_1&email=' + remail;
        globalRfcZip = frm.city_state_zip2.value;
        globalRfcPhone = frm.phone.value;
        $.when($.ajax({
          type: 'POST',
          url: ajaxurl,
          data: ajaxdata,
          beforeSend: function beforeSend(xhr) {
            $('#btnrfcsubmit').attr('disabled', 'disabled');
            $('#ajaxloaderimg, .ajaxloaderimg').show();
          }
        })).done(function (res) {
          globalLeadID = $.trim(res);
          globalLeadID = globalLeadID.split('-')[1];
          $('#popup_rfc_step2 #step1_first_name').val(frm.first_name.value);
          $('#popup_rfc_step2 #step1_last_name').val(frm.last_name.value);
          $('#popup_rfc_step2 #step1_email').val(frm.email.value);
          $('#popup_rfc_step2 #rphone, #popup_rfc_step2 .rphone').val(frm.phone.value);
          $('#popup_rfc_step2 #city_state_zip2').val(frm.city_state_zip2.value);
          setTimeout(function () {
            $('#ajaxloaderimg, .ajaxloaderimg').hide();
            $('#popup_rfc_step2').modal('show');
          }, 500);
        });
      }
      return false;
    }
  });
  $('#popup_rfc_step2').on('show.bs.modal', function () {
    $('#popup_rfc_step2 #city_state_zip2').val(globalRfcZip);
    $('#popup_rfc_step2 #rphone, #popup_rfc_step2 .rphone').val(globalRfcPhone);
    $('#popup_rfc_step2 #lid').val(globalLeadID);
  });
  $('#popup_rfc_step2').on('hidden.bs.modal', function () {
    if (runStep2 == 3) {
      runStep2 = 0;
      $('#popup_rfc_thank').modal('show');
    } else {
      $('input#btnrfcsubmit, button').removeAttr('disabled');
      $('#ajaxloaderimg, .ajaxloaderimg').hide();
    }
  });
  $('#cmdrfccancel').click(function () {
    $('#popup_rfc_step2').modal('hide');
  });
  var valRfcformrightside = $('#rfcformrightside').validate({
    ignore: ':hidden',
    rules: {
      first_name: {
        required: true,
        lettersonly: true
      },
      last_name: {
        required: true,
        lettersonly: true
      },
      email: {
        required: true,
        email: true
      },
      phone: {
        required: true,
        minlength: 12,
        maxlength: 12
      },
      country: {
        required: true
      },
      ragree2: {
        required: true
      },
      city_state_zip2: {
        customzip: true
      }
    },
    messages: {
      first_name: {
        required: 'This field is required'
      },
      last_name: {
        required: 'This field is required'
      },
      email: {
        required: 'This field is required.',
        email: 'Please enter a valid email id.'
      },
      phone: {
        required: 'This field is required',
        minlength: 'Please enter minimum 10 numbers.',
        maxlength: 'Please enter maximum 10 numbers.'
      },
      country: {
        required: 'Please Select the Country name'
      },
      ragree2: {
        required: 'Please read and agree with terms and conditions.'
      }
    },
    submitHandler: function submitHandler(frm) {
      var ajaxurl = $('#admin-ajax-url').val();
      var ajaxdata = $('#rfcformrightside').serialize() + '&action=requestfc_step_1';

      //Check if User has closed the Step2 and then again filling step1.
      //If yes then check if Step1 Data has not been changed
      //It can be checked as when first step is submitted, its data is stored into second step too
      //(in  hidden inputs)

      var second_step_fname = $('#popup_rfc_step2 #step1_first_name').val();
      var second_step_lname = $('#popup_rfc_step2 #step1_last_name').val();
      var second_step_email = $('#popup_rfc_step2 #step1_email').val();
      var second_step_phone = $('#popup_rfc_step2 #rphone').val();
      var second_step_zip = $('#popup_rfc_step2 #city_state_zip2').val();
      var second_step_country = $('#popup_rfc_step2 .cc-custom-select').val();
      var second_step_subs = $('#popup_rfc_step2 #step1_subs').val();
      var firstStepSubs = $('form#rfcformrightside #subsc2').is(':checked') ? 1 : 2;
      if ($.trim(frm.first_name.value) == $.trim(second_step_fname) && $.trim(frm.last_name.value) == $.trim(second_step_lname) && $.trim(frm.phone.value) == $.trim(second_step_phone) && $.trim(frm.email.value) == $.trim(second_step_email) && $.trim(frm.city_state_zip2.value) == $.trim(second_step_zip) && second_step_subs == firstStepSubs && second_step_country == $.trim(frm.country.value) && $('#popup_rfc_step2 #lid').val() != '') {
        $('#btnrfcsubmit').attr('disabled', 'disabled');
        $('#hidden-request-content2').modal('hide');
        setTimeout(function () {
          $('#popup_rfc_step2').modal('show');
        }, 500);
        $('#ajaxloaderimg').hide();
      } else {
        globalRfcZip = frm.city_state_zip2.value;
        globalRfcPhone = frm.phone.value;
        $.when($.ajax({
          type: 'POST',
          url: ajaxurl,
          data: ajaxdata,
          beforeSend: function beforeSend(xhr) {
            $('#btnrfcsubmit').attr('disabled', 'disabled');
            $(frm).find('#ajaxloaderimg2').show();
          }
        })).done(function (res) {
          globalLeadID = $.trim(res);
          globalLeadID = globalLeadID.split('-')[1];
          $('#popup_rfc_step2 #step1_first_name').val(frm.first_name.value);
          $('#popup_rfc_step2 #step1_last_name').val(frm.last_name.value);
          $('#popup_rfc_step2 #step1_email').val(frm.email.value);
          $('#popup_rfc_step2 #rphone').val(frm.phone.value);
          $('#popup_rfc_step2 #city_state_zip2').val(frm.city_state_zip2.value);
          var firstStepSubs = $('form#rfcformrightside #subsc2').is(':checked') ? 1 : 2;
          $('#popup_rfc_step2 #step1_subs').val(firstStepSubs);

          //Check Country Now---
          var firstStepCtry = frm.country.value;
          if (firstStepCtry == 'us' || firstStepCtry == '' || typeof firstStepCtry === 'undefined') {
            $('#popup_rfc_step2 select.mexico, #popup_rfc_step2 select.canada, #popup_rfc_step2 select.puerto, #popup_rfc_step2 select.distrito').hide();
            $('#popup_rfc_step2 select.united').show();
            firstStepCtry = 'us';
          } else if (firstStepCtry == 'mx') {
            $('#popup_rfc_step2 select.united, #popup_rfc_step2 select.canada, #popup_rfc_step2 select.puerto, #popup_rfc_step2 select.distrito').hide();
            $('#popup_rfc_step2 select.mexico').show();
          } else if (firstStepCtry == 'ca') {
            $('#popup_rfc_step2 select.united, #popup_rfc_step2 select.mexico, #popup_rfc_step2 select.puerto, #popup_rfc_step2 select.distrito').hide();
            $('#popup_rfc_step2 select.canada').show();
          } else if (firstStepCtry == 'pr') {
            $('#popup_rfc_step2 select.united, #popup_rfc_step2 select.mexico, #popup_rfc_step2 select.canada, #popup_rfc_step2 select.distrito').hide();
            $('#popup_rfc_step2 select.puerto').show();
          } else if (firstStepCtry == 'do') {
            $('#popup_rfc_step2 select.united, #popup_rfc_step2 select.mexico, #popup_rfc_step2 select.canada, #popup_rfc_step2 select.puerto').hide();
            $('#popup_rfc_step2 select.distrito').show();
          }
          $('#popup_rfc_step2 select.cc-custom-select').val(firstStepCtry);
          $('#hidden-request-content2').modal('hide');
          setTimeout(function () {
            $('#popup_rfc_step2').modal('show');
          }, 500);
          $(frm).find('#ajaxloaderimg2').hide();
        });
      }
      return false;
    }
  });
  $('#rfcform3').validate({
    ignore: ':hidden',
    rules: {
      zipcode: {
        customzip: true
      },
      phone2: {
        required: true,
        minlength: 12,
        maxlength: 12
      }
    },
    messages: {
      phone2: {
        required: 'This field is required',
        minlength: 'Please enter minimum 10 characters.',
        maxlength: 'Please enter maximum 10 characters.'
      }
    },
    submitHandler: function submitHandler(frm) {
      runStep2 = 1;
      var leadid = frm.leadid.value;
      if (typeof leadid === 'undefined' || leadid == '') {
        alert('Data is not sufficient. Please try again.');
        window.location.href = siteURL;
      }
      var ajaxdata = $('#rfcform3').serialize() + '&action=requestfc_step_2';
      var ajaxurl = $('#admin-ajax-url').val();
      $.when($.ajax({
        type: 'POST',
        url: ajaxurl,
        data: ajaxdata,
        beforeSend: function beforeSend(xhr) {
          $('input#cmdrfcsubmit').attr('disabled', 'disabled');
          $(frm).find('#ajaxloaderimg, .ajaxloaderimg').show();
        }
      })).done(function (res) {
        res = $.trim(res);
        $('#ajaxloaderimg, .ajaxloaderimg').hide();
        if (res == 'Done') {
          runStep2 = 3;
          $('#popup_rfc_step2').modal('hide');
          var countryname = $('.conname').val();
          if (countryname == 'ca') {
            $('.us-thank-msg').hide();
            $('.ca-thank-msg').show();
          } else {
            $('.us-thank-msg').show();
            $('.ca-thank-msg').hide();
          }

          // Reset Fields of all forms.
          $('form#rfcformrightside').find('input:text, select, textarea').val('');
          $('form#rfcformrightside #subsc2').prop('checked', true);
          $('form#rfcformrightside #ragree2').prop('checked', false);
          $('form#rfcform2').find('input:text, select, textarea').val('');
          $('form#rfcform2 #ragree').prop('checked', false);
          $('form#rfcform3').find('input:text, select, textarea, input:hidden').val('');
          $('form#rfcform3').find('input:checkbox').prop('checked', false);
          valRfcformrightside.resetForm();
          valRfcform2.resetForm();
        } else {
          alert('There is some issue. Please try again.');
        }
        $('input#cmdrfcsubmit, button').removeAttr('disabled');
      });
      return false;
    }
  });
});